import axios from "axios";
import { ChangePasswordRequest } from "../models/change-password";

export const AUTH_URL = `Auth`;

export const authServices = {
  changePassword: function (data: ChangePasswordRequest) {
    return axios.post(`${AUTH_URL}/change-password`, data);
  },
};
